import { Drawer } from "antd";
import React, { useEffect, useState } from "react";
import crossIcon from "../../assets/icons/cancelicon.png";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1600px,
  _1500px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _2200px,
  _991px,
} from "../../utils/mediaBreakpoints";

const DropDown = ({
  options = [],
  setOnHover,
  drawerItem = false,
  open,
  setOpen,
  link,
  mainPageName,
}) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _991 = useMediaQuery({ maxWidth: _991px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });
  const [selectOptions, setSelectOptions] = useState([]);

  const onClose = () => {
    setOpen("");
  };

  useEffect(() => {
    if (options?.length <= 0) {
      return;
    } else {
      let tempOptions = [];
      tempOptions.push({ value: link, label: mainPageName });
      options?.forEach((element) => {
        tempOptions.push({
          value: element?.link?.link,
          label: element?.link?.name,
        });
      });
      setSelectOptions(tempOptions);
    }
  }, [options]);
  console.log(link);
  return (
    <>
      {!drawerItem ? (
        <div
          className="d-flex flex-column gap-2 position-absolute px-3 pb-2 z-0"
          style={{
            paddingTop:"-40px",
            background:
              "linear-gradient(180.14deg, #0B2039 10% , #000000 90%)",
            width: _576
            ? "12px"
            : _768
            ? "12px"
            : _992
            ? "17px"
            : _1200
            ? "170px"
            : _1400
            ? "160px"
            : _1600
            ? "165px"
            : _1700
            ? "180px"
            : _1800
            ? "195px"
            : "200px",
            top: 
               _1400
              ? "46.2px"
               :_1500
              ? "46.2px"
              : _1600
              ? "48.2px"
              : _1700
              ? "48.2px"
              : _1800
              ? "54.2px"
              : "54.5px",
            boxShadow: "0 3px 8px rgba(0, 57, 236, 0.3), -3px 0 8px rgba(0, 57, 236, 0.3), 3px 0 8px rgba(0, 57, 236, 0.3)"
          }}
          onMouseLeave={() => setOnHover("")}
        >
          {/* {link !== "#mena" && (
            <>
              <span className="text-white fs-6">Ask Fides is for </span>
              <hr style={{ color: "white" }}></hr>
            </>
          )} */}

          <div className="d-flex flex-column">
            {selectOptions?.map((data, idx) => (
              <Link
              style={{paddingTop:idx === 0?"-16px":"",fontSize:
                _576
               ? "16px"
               : _768
               ? "16px"
               : _992
               ? "16px"
               : _1200
               ? "12px"
               : _1400
               ? "12px"
               : _1600
               ? "13px"
               : _1700
               ? "14px"
               : _1800
               ? "16px"
               :"16px"}}
                key={idx}
                to={data?.value}
                className={`text-decoration-none text-white ${idx > 0?"py-2":""} ${
                  idx !== 0 && idx !== selectOptions.length - 1
                    ? "border-1 border-bottom"
                    : ""
                } bot`}
                
              >
                {data?.label}
              </Link>
            ))}
          </div>
        </div>
      ) : (
        <Drawer
          style={{
            background:
              " linear-gradient(142.14deg, #0075FF -54.25%, #000000 37.85%)",
          }}
          onClose={onClose}
          closeIcon={<img src={crossIcon} alt="" width={15} height={15} />}
          open={open}
          placement="left"
        >
          <div className="d-flex flex-column gap-3">
            {/* {link !== "#mena" && (
              <>
                <span className="text-white fs-6">Ask Fides is for </span>
                <hr style={{ color: "white" }}></hr>
              </>
            )} */}

            <div className="d-flex flex-column gap-3">
              {selectOptions?.map((data, idx) => (
                <Link
                  key={idx}
                  to={data?.value}
                  className="text-decoration-none text-white fs18"
                >
                  {data?.label}
                </Link>
              ))}
            </div>
          </div>
        </Drawer>
      )}
    </>
  );
};

export default DropDown;
